import React from 'react';
import OrganizationMoments from 'screens/organizations/components/OrganizationMoments';
import { MemberOnlyOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';

const OrganizationMomentsScreen = () => <OrganizationMoments />;

export default OrganizationMomentsScreen;

OrganizationMomentsScreen.getLayout = (page) => (
  <MemberOnlyOrganizationWrapper>{page}</MemberOnlyOrganizationWrapper>
);
